export default __webpack_public_path__ + "static/media/ich-ghoere-es-gloeggli.d535cccc.png";